/* ═══════════════════════════════════════════════════
   STRABELLA THEME — theme.js
   CVR-Optimized Shopify Theme JS
   ═══════════════════════════════════════════════════ */

'use strict';

(function () {

  // ── UTILITY ──────────────────────────────────────────────
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
  const money = (cents) => {
    const fmt = window.Strabella.moneyFormat || '${{amount}}';
    return fmt.replace('{{amount}}', (cents / 100).toFixed(2));
  };
  const escapeHTML = (str) => {
    if (!str) return '';
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  };

  // ── HEADER SCROLL ──
  const header = $('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ── ANNOUNCEMENT BAR ──
  const announceClose = $('.announcement-bar__close');
  if (announceClose) {
    announceClose.addEventListener('click', () => {
      const bar = $('.announcement-bar');
      if (bar) { bar.style.display = 'none'; }
    });
  }

  // ── MOBILE NAV ──
  const mobileNav = $('#mobile-nav');
  const mobileOverlay = $('.mobile-nav-overlay');
  function closeMobileNav() {
    mobileNav?.classList.remove('is-open');
    mobileOverlay?.classList.remove('is-visible');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-action]');
    if (!el) return;
    const action = el.dataset.action;
    const also = el.dataset.also;
    if (action === 'open-mobile-nav') {
      mobileNav?.classList.add('is-open');
      mobileOverlay?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    if (action === 'close-mobile-nav' || also === 'close-mobile-nav') {
      closeMobileNav();
    }
  });

  // ── CART STATE ──
  let cartData = null;

  async function fetchCart() {
    const res = await fetch('/cart.js');
    cartData = await res.json();
    return cartData;
  }

  async function addToCart(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Failed to add to cart');
    }
    const data = await res.json();
    await fetchCart();
    updateCartUI();
    return data;
  }

  async function updateCartItem(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!res.ok) {
      console.warn('Cart update failed:', res.status);
      return;
    }
    await fetchCart();
    updateCartUI();
  }

  function updateCartUI() {
    if (!cartData) return;
    const count = cartData.item_count;
    const total = cartData.total_price;

    // Cart count badge
    $$('#cart-count, .cart-count').forEach(el => {
      el.textContent = count;
      el.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
      el.classList.add('bump');
      setTimeout(() => el.classList.remove('bump'), 400);
    });

    // Cart drawer title
    const drawerCount = $('#cart-drawer-count');
    if (drawerCount) drawerCount.textContent = `(${count})`;

    // Cart subtotal
    const subtotalEl = $('#cart-subtotal');
    if (subtotalEl) subtotalEl.textContent = money(total);

    // Shipping progress
    updateShippingBar(total);

    // Rebuild cart items
    renderCartItems();

    // Show upsell if applicable
    showCartUpsell();
  }

  function updateShippingBar(total) {
    const threshold = window.Strabella.freeShippingThreshold || 2500;
    const bar = $('#shipping-bar-fill');
    const text = $('#shipping-bar-text');
    if (!bar || !text) return;
    const pct = Math.min((total / threshold) * 100, 100);
    bar.style.width = pct + '%';
    if (total >= threshold) {
      text.innerHTML = 'Free shipping unlocked';
    } else {
      const remaining = escapeHTML(money(threshold - total));
      text.innerHTML = `Add <strong>${remaining}</strong> more for free shipping`;
    }
  }

  function renderCartItems() {
    const container = $('#cart-items');
    if (!container || !cartData) return;
    if (cartData.items.length === 0) {
      container.innerHTML = `<div class="cart-empty"><p>Your cart is empty.</p><a href="/collections" class="btn btn--primary" data-action="close-cart">Start Shopping</a></div>`;
      return;
    }
    container.innerHTML = cartData.items.map((item, i) => `
      <div class="cart-item" data-variant-id="${item.variant_id}">
        <a href="${escapeHTML(item.url)}" class="cart-item__img">
          <img src="${item.image ? escapeHTML(item.image.replace('_large', '_compact_cropped')) : '//:0'}" alt="${escapeHTML(item.title)}" loading="lazy" width="72" height="72">
        </a>
        <div class="cart-item__info">
          <a href="${escapeHTML(item.url)}" class="cart-item__title">${escapeHTML(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${escapeHTML(item.variant_title)}</p>` : ''}
          <div class="cart-item__bottom">
            <div class="cart-item__qty">
              <button class="cart-qty-btn" data-action="cart-decrease" data-line="${i + 1}">−</button>
              <span>${item.quantity}</span>
              <button class="cart-qty-btn" data-action="cart-increase" data-line="${i + 1}">+</button>
            </div>
            <span class="cart-item__price">${money(item.line_price)}</span>
          </div>
        </div>
        <button class="cart-item__remove" data-action="cart-remove" data-line="${i + 1}" aria-label="Remove ${escapeHTML(item.title)}">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>
        </button>
      </div>
    `).join('');
  }

  // ── CART DRAWER ──
  const cartOverlay = $('#cart-overlay');

  function openCart() {
    if (!cartOverlay) return;
    fetchCart().then(updateCartUI);
    cartOverlay.classList.add('is-open');
    cartOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    if (!cartOverlay) return;
    cartOverlay.classList.remove('is-open');
    cartOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const action = e.target.closest('[data-action]')?.dataset.action;
    if (action === 'open-cart') { e.preventDefault(); openCart(); }
    if (action === 'close-cart') { closeCartDrawer(); }
    // Close drawer when clicking backdrop (outside the drawer panel)
    // ::before has pointer-events:none so e.target will be cartOverlay when backdrop is clicked
    if (e.target === cartOverlay && !e.target.closest('#cart-drawer')) { closeCartDrawer(); }
    if (action === 'cart-decrease') {
      const lineEl = e.target.closest('[data-line]');
      if (!lineEl) return;
      const line = parseInt(lineEl.dataset.line);
      if (isNaN(line)) return;
      const item = cartData?.items[line - 1];
      if (item) updateCartItem(line, item.quantity - 1);
    }
    if (action === 'cart-increase') {
      const lineEl = e.target.closest('[data-line]');
      if (!lineEl) return;
      const line = parseInt(lineEl.dataset.line);
      if (isNaN(line)) return;
      const item = cartData?.items[line - 1];
      if (item) updateCartItem(line, item.quantity + 1);
    }
    if (action === 'cart-remove') {
      const lineEl = e.target.closest('[data-line]');
      if (!lineEl) return;
      const line = parseInt(lineEl.dataset.line);
      if (isNaN(line)) return;
      updateCartItem(line, 0);
    }
  });

  // ── ADD TO CART (Shopify standard form with AJAX enhancement) ──
  const productForm = $('#product-form');
  const atcBtn = $('#add-to-cart-btn');
  const stickyAtcBtn = $('#sticky-atc-btn');

  // AJAX add to cart — intercepts Shopify form submit for smooth UX
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formData = new FormData(productForm);
      const variantId = parseInt(formData.get('id'));
      const quantity = parseInt(formData.get('quantity') || 1);

      // If no valid variant, let Shopify handle it natively
      if (!variantId || isNaN(variantId)) {
        productForm.submit();
        return;
      }

      const origText = atcBtn ? atcBtn.textContent.trim() : '';
      if (atcBtn) { atcBtn.textContent = 'Adding...'; atcBtn.disabled = true; }

      try {
        await addToCart([{ id: variantId, quantity }]);
        if (atcBtn) { atcBtn.textContent = '✓ Added!'; }
        setTimeout(() => {
          if (atcBtn) { atcBtn.textContent = origText || 'Add to Cart →'; atcBtn.disabled = false; }
        }, 1500);
        showUpsellModal();
      } catch (err) {
        console.error('ATC error:', err);
        // Fallback: let Shopify handle it natively
        productForm.submit();
      }
    });
  }

  // Sticky ATC bar — triggers main product form submit
  stickyAtcBtn?.addEventListener('click', () => {
    if (productForm) {
      productForm.requestSubmit ? productForm.requestSubmit() : productForm.submit();
    }
  });

  // ── BUNDLE ATC ──
  const bundleBtn = $('#bundle-atc-btn');
  bundleBtn?.addEventListener('click', async () => {
    const mainVariantId = parseInt(bundleBtn.dataset.mainVariant);
    const bundleVariants = (bundleBtn.dataset.bundleVariants || '').split(',').filter(Boolean);
    const items = [{ id: mainVariantId, quantity: 1 }];
    bundleVariants.forEach(id => { if (id) items.push({ id: parseInt(id), quantity: 1 }); });
    bundleBtn.textContent = 'Adding...';
    bundleBtn.disabled = true;
    try {
      await addToCart(items);
      bundleBtn.textContent = '✓ Added to Cart!';
      setTimeout(() => openCart(), 400);
    } catch (e) {
      bundleBtn.textContent = 'Error — Try Again';
      bundleBtn.disabled = false;
    }
  });

  // ── QUICK ADD ──
  document.addEventListener('click', async (e) => {
    const quickAdd = e.target.closest('[data-action="quick-add"]');
    if (!quickAdd) return;
    const variantId = parseInt(quickAdd.dataset.variantId);
    const title = quickAdd.dataset.productTitle || '';
    quickAdd.textContent = '✓';
    try {
      await addToCart([{ id: variantId, quantity: 1 }]);
      showToast({ type: 'cart', message: `${title} added to cart` });
      setTimeout(() => openCart(), 500);
    } catch (e) {
      quickAdd.textContent = 'Error';
    }
    setTimeout(() => { quickAdd.textContent = '+ Quick Add'; }, 2000);
  });

  // ── VARIANT SELECTION ──
  const variantData = window.productVariants || null;

  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.color-swatch');
    if (swatch) {
      const group = swatch.closest('.product-variant-group');
      $$('.color-swatch', group).forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');
      const idx = group.dataset.optionIndex;
      const val = swatch.dataset.value;
      const label = $(`#option-selected-${idx}`);
      if (label) label.textContent = val;
      updateVariantSelection();
    }
    const pill = e.target.closest('.size-pill');
    if (pill && !pill.classList.contains('is-sold-out')) {
      const group = pill.closest('.product-variant-group');
      $$('.size-pill', group).forEach(p => p.classList.remove('is-active'));
      pill.classList.add('is-active');
      const idx = group.dataset.optionIndex;
      const val = pill.dataset.value;
      const label = $(`#option-selected-${idx}`);
      if (label) label.textContent = val;
      updateVariantSelection();
    }
  });

  function updateVariantSelection() {
    // Collect selected options
    const opts = [];
    $$('.product-variant-group').forEach(g => {
      const active = g.querySelector('.is-active');
      if (active) opts.push(active.dataset.value);
    });
    // Update variant ID via Shopify product JSON
    const productData = window.productJSON;
    if (!productData) return;
    const match = productData.variants.find(v =>
      opts.every((opt, i) => v[`option${i + 1}`] === opt)
    );
    if (match) {
      const idInput = $('#variant-id');
      if (idInput) idInput.value = match.id;
      // Sync Buy Now form variant
      const buyNowVariant = document.querySelector('.buy-now-variant-id');
      if (buyNowVariant) buyNowVariant.value = match.id;

      // Update URL without reload
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState(null, '', url.toString());

      // Update price
      const priceEl = $('#product-price');
      if (priceEl) {
        priceEl.innerHTML = `
          <span class="price-current">${money(match.price)}</span>
          ${match.compare_at_price > match.price ? `<span class="price-original">${money(match.compare_at_price)}</span><span class="price-save">Save ${money(match.compare_at_price - match.price)}</span>` : ''}
        `;
      }

      // Update ATC button
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        if (match.available) {
          atcBtn.textContent = 'Add to Cart →';
        } else {
          atcBtn.textContent = 'Sold Out';
        }
      }
      // Shopify dynamic checkout button state (handled by Shopify automatically)

      // Update sticky cart prices & variant
      const stickyPrice = document.getElementById('sticky-price');
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      const stickyBtnPrice = document.getElementById('sticky-btn-price');
      if (stickyBtnPrice) stickyBtnPrice.textContent = money(match.price);
      const stickyCompare = document.getElementById('sticky-compare');
      const stickyBtnCompare = document.getElementById('sticky-btn-compare');
      if (match.compare_at_price > match.price) {
        if (stickyCompare) { stickyCompare.style.display = ''; stickyCompare.innerHTML = '<s>' + money(match.compare_at_price) + '</s>'; }
        if (stickyBtnCompare) { stickyBtnCompare.style.display = ''; stickyBtnCompare.innerHTML = '<s>' + money(match.compare_at_price) + '</s>'; }
      } else {
        if (stickyCompare) stickyCompare.style.display = 'none';
        if (stickyBtnCompare) stickyBtnCompare.style.display = 'none';
      }
      const stickyVariant = document.getElementById('sticky-variant-text');
      if (stickyVariant) stickyVariant.textContent = match.title;

      // Update gallery — switch to variant's featured image slide
      if (match.featured_image) {
        const allSlides = $$('.product-gallery__slide');
        const mediaId = String(match.featured_image.id);
        let found = false;
        // Primary: match by data-media-id (reliable, no filename issues)
        allSlides.forEach((slide, i) => {
          if (slide.dataset.mediaId === mediaId) {
            goToSlide(i);
            found = true;
          }
        });
        // Fallback: match by filename base (strip Shopify _800x size suffixes)
        if (!found) {
          const rawFile = match.featured_image.src.split('/').pop().split('?')[0];
          const imgBase = rawFile.replace(/_\d+x\d*\.[a-z]+$/i, '').replace(/\.[a-z]+$/i, '');
          allSlides.forEach((slide, i) => {
            const slideImg = slide.querySelector('img');
            if (!found && slideImg && imgBase && slideImg.src.includes(imgBase)) {
              goToSlide(i);
              found = true;
            }
          });
        }
        if (!found) {
          const mainImg = $('#gallery-featured-img');
          if (mainImg) {
            const newSrc = match.featured_image.src.replace(/(\.[^.?]+)(\?|$)/, '_800x$1$2');
            mainImg.src = newSrc;
          }
        }
        // Update sticky cart thumbnail
        const stickyImg = document.getElementById('sticky-atc-img');
        if (stickyImg) stickyImg.src = match.featured_image.src.replace(/(\.[^.?]+)(\?|$)/, '_80x$1$2');
      }

      // Update swatch checkmarks
      $$('.color-swatch').forEach(s => {
        s.innerHTML = s.classList.contains('is-active') ? '<svg viewBox="0 0 10 8"><path d="M1 4l3 3 5-6" fill="none" stroke="white" stroke-width="1.5"/></svg>' : '';
      });
    }
  }

  // ── GALLERY (images + videos) ──
  let currentMediaIndex = 0;
  const slides = () => $$('.product-gallery__slide');
  const thumbs = () => $$('.product-gallery__thumb');

  function goToSlide(index) {
    const allSlides = slides();
    const allThumbs = thumbs();
    if (!allSlides.length) return;
    index = ((index % allSlides.length) + allSlides.length) % allSlides.length;
    currentMediaIndex = index;

    allSlides.forEach((s, i) => {
      s.classList.toggle('is-active', i === index);
      // Pause videos not in view
      const video = s.querySelector('video');
      if (video) { if (i === index) { video.play().catch(() => {}); } else { video.pause(); } }
    });
    allThumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));

    const counter = $('#gallery-counter');
    if (counter) counter.textContent = `${index + 1} / ${allSlides.length}`;
  }

  // Thumb click
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.product-gallery__thumb');
    if (!thumb) return;
    const idx = parseInt(thumb.dataset.index);
    goToSlide(idx);
  });

  // Arrow click
  $('#gallery-prev')?.addEventListener('click', () => goToSlide(currentMediaIndex - 1));
  $('#gallery-next')?.addEventListener('click', () => goToSlide(currentMediaIndex + 1));

  // Swipe support (mobile)
  let touchStartX = 0;
  const galleryMain = $('#gallery-main');
  if (galleryMain) {
    galleryMain.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', (e) => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goToSlide(currentMediaIndex + (diff > 0 ? 1 : -1));
    });
  }

  // ── QUANTITY ──
  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('.qty-btn');
    if (!qtyBtn) return;
    const input = qtyBtn.closest('.qty-selector')?.querySelector('.qty-input');
    if (!input) return;
    const action = qtyBtn.dataset.action;
    const val = parseInt(input.value);
    if (action === 'decrease') input.value = Math.max(1, val - 1);
    if (action === 'increase') input.value = Math.min(99, val + 1);
  });

  // ── FAQ ACCORDION ──
  // Bu handler kaldırıldı: initFAQ() direkt listener ekliyor, çift handler çakışmasına neden oluyordu.
  // İki handler aynı anda çalışınca isOpen değeri tutarsız hale geliyordu → FAQ hiç açılmıyordu.
  // Çözüm: Sadece initFAQ()'daki direkt listener kullanılıyor (aria-expanded de eklendi).

  // ── ACCORDION ──
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-accordion]');
    if (!trigger) return;
    const item = trigger.closest('.accordion-item');
    const isOpen = item.classList.contains('is-open');
    $$('.accordion-item').forEach(i => i.classList.remove('is-open'));
    if (!isOpen) item.classList.add('is-open');
  });

  // ── STICKY ATC ──
  // NOT: getBoundingClientRect() scroll event içinde "forced reflow" tetikliyordu.
  // Dosyanın altındaki IntersectionObserver bu görevi daha verimli yapıyor,
  // bu yüzden scroll tabanlı listener kaldırıldı (PageSpeed: Forced reflow hatası giderildi).
  const stickyAtcBar = $('#sticky-atc');

  // ── UPSELL MODAL ──
  const upsellModal = $('#upsell-modal');
  const upsellConfig = window.StrabellaUpsell || null;

  function showUpsellModal() {
    if (!upsellModal || !upsellConfig) {
      openCart();
      return;
    }
    const product = upsellConfig.product;
    const discountedPrice = Math.round(product.price * 0.8);
    const productEl = $('#upsell-modal-product');
    if (productEl) {
      productEl.innerHTML = `
        <div class="upsell-modal__product-img">
          ${product.image ? `<img src="${escapeHTML(product.image)}" alt="${escapeHTML(product.title)}" loading="lazy">` : '🍵'}
        </div>
        <div>
          <div class="upsell-modal__product-name">${escapeHTML(product.title)}</div>
          <div class="upsell-modal__product-price">
            <s>${money(product.price)}</s> ${money(discountedPrice)}
          </div>
        </div>
      `;
    }
    const acceptBtn = $('#upsell-modal-accept');
    if (acceptBtn) {
      acceptBtn.textContent = `Yes! Add ${product.title} — ${money(discountedPrice)}`;
      acceptBtn.onclick = async () => {
        acceptBtn.textContent = 'Adding...';
        await addToCart([{ id: product.variant_id, quantity: 1 }]);
        closeUpsellModal();
        openCart();
      };
    }
    upsellModal.style.display = '';
    upsellModal.classList.add('is-open');
    upsellModal.setAttribute('aria-hidden', 'false');
  }

  function closeUpsellModal() {
    if (!upsellModal) return;
    upsellModal.classList.remove('is-open');
    upsellModal.setAttribute('aria-hidden', 'true');
    setTimeout(() => { upsellModal.style.display = 'none'; }, 300);
  }

  $('#upsell-modal-close')?.addEventListener('click', () => { closeUpsellModal(); openCart(); });
  $('#upsell-modal-decline')?.addEventListener('click', () => { closeUpsellModal(); openCart(); });
  upsellModal?.addEventListener('click', (e) => { if (e.target === upsellModal) { closeUpsellModal(); openCart(); } });

  // ── IN-CART UPSELL ──
  function showCartUpsell() {
    const upsell = $('#cart-upsell');
    const upsellProduct = window.StrabellaCartUpsell;
    if (!upsell || !upsellProduct || !cartData) return;
    // Only show if upsell product not already in cart
    const inCart = cartData.items.some(i => i.product_id === upsellProduct.product_id);
    if (inCart) { upsell.style.display = 'none'; return; }
    const discounted = Math.round(upsellProduct.price * 0.85);
    const productEl = $('#cart-upsell-product');
    if (productEl) {
      productEl.innerHTML = `
        <div class="cart-upsell__img">${upsellProduct.image ? `<img src="${escapeHTML(upsellProduct.image)}" alt="${escapeHTML(upsellProduct.title)}" loading="lazy">` : '🍵'}</div>
        <div class="cart-upsell__text">
          ${escapeHTML(upsellProduct.title)}
          <div><span class="cart-upsell__price">${money(discounted)}</span> <s style="font-size:12px;color:#aaa">${money(upsellProduct.price)}</s></div>
        </div>
        <button class="cart-upsell__add" data-action="cart-upsell-add" data-variant="${upsellProduct.variant_id}">+ Add</button>
      `;
    }
    upsell.style.display = 'block';
  }

  document.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('[data-action="cart-upsell-add"]');
    if (!addBtn) return;
    const variantId = parseInt(addBtn.dataset.variant);
    addBtn.textContent = '...';
    addBtn.disabled = true;
    await addToCart([{ id: variantId, quantity: 1 }]);
    addBtn.textContent = '✓ Added';
    addBtn.style.background = 'var(--sage)';
  });

  // ── TOAST NOTIFICATION ──
  let toastTimer = null;
  const socialProof = [
    { emoji: '😊', name: 'Sarah', loc: 'New York', item: 'Dish Drying Mat × 2', time: '2 min ago' },
    { emoji: '👩', name: 'Maria', loc: 'Los Angeles', item: 'Matcha Whisk Set', time: '4 min ago' },
    { emoji: '🧑', name: 'Carlos', loc: 'Chicago', item: 'Bundle Pack', time: '7 min ago' },
    { emoji: '👤', name: 'Emily', loc: 'Austin', item: 'Dish Drying Mat + Shower Mat', time: '11 min ago' },
    { emoji: '😃', name: 'James', loc: 'Seattle', item: 'Matcha Whisk Set × 2', time: '15 min ago' },
  ];
  let spIdx = 0;

  function showToast({ type = 'social', message = '', emoji = '👤' } = {}) {
    const toast = $('#toast');
    if (!toast) return;
    const avatarEl = $('#toast-avatar');
    const titleEl = $('#toast-title');
    const msgEl = $('#toast-message');
    const timeEl = $('#toast-time');

    if (type === 'cart') {
      if (avatarEl) avatarEl.textContent = '🛒';
      if (titleEl) { titleEl.textContent = '✓ Added to cart!'; titleEl.style.color = 'var(--sage)'; }
      if (msgEl) msgEl.textContent = message;
      if (timeEl) timeEl.textContent = 'Just now';
    } else {
      const sp = socialProof[spIdx % socialProof.length];
      spIdx++;
      if (avatarEl) avatarEl.textContent = sp.emoji;
      if (titleEl) { titleEl.textContent = '🛒 Just purchased!'; titleEl.style.color = 'var(--copper)'; }
      if (msgEl) msgEl.textContent = `${sp.name} from ${sp.loc} bought ${sp.item}`;
      if (timeEl) timeEl.textContent = sp.time;
    }

    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 4500);
  }

  $('#toast-close')?.addEventListener('click', () => {
    clearTimeout(toastTimer);
    $('#toast')?.classList.remove('is-visible');
  });

  // Auto social proof toasts — max 1 per session
  if (document.body.classList.contains('template-product')) {
    try {
      if (!sessionStorage.getItem('strabella_toast_shown')) {
        setTimeout(() => {
          showToast({ type: 'social' });
          try { sessionStorage.setItem('strabella_toast_shown', '1'); } catch(e) {}
        }, 5000);
      }
    } catch(e) {
      // sessionStorage unavailable, show once only
      setTimeout(() => showToast({ type: 'social' }), 5000);
    }
  }

  // ── SEARCH ──
  const searchOverlay = $('#search-overlay');
  let searchTimeout;

  document.addEventListener('click', (e) => {
    const action = e.target.closest('[data-action]')?.dataset.action;
    if (action === 'open-search') {
      searchOverlay?.classList.add('is-open');
      searchOverlay?.setAttribute('aria-hidden', 'false');
      setTimeout(() => $('#search-panel-input')?.focus(), 100);
    }
    if (action === 'close-search') {
      searchOverlay?.classList.remove('is-open');
      searchOverlay?.setAttribute('aria-hidden', 'true');
    }
  });

  $('#search-panel-input')?.addEventListener('input', (e) => {
    clearTimeout(searchTimeout);
    const q = e.target.value.trim();
    if (q.length < 2) {
      const results = $('#search-panel-results');
      if (results) results.innerHTML = '<p class="search-panel__hint">Start typing to search...</p>';
      return;
    }
    searchTimeout = setTimeout(() => performSearch(q), 300);
  });

  async function performSearch(q) {
    const results = $('#search-panel-results');
    if (!results) return;
    results.innerHTML = '<p class="search-panel__hint">Searching...</p>';
    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      if (products.length === 0) {
        results.innerHTML = '<p class="search-panel__hint">No results found.</p>';
        return;
      }
      results.innerHTML = products.map(p => `
        <a href="${escapeHTML(p.url)}" class="search-result" style="display:flex;align-items:center;gap:12px;padding:10px 0;border-bottom:1px solid var(--border);text-decoration:none;color:var(--charcoal);" data-action="close-search">
          <img src="${escapeHTML(p.image)}" alt="${escapeHTML(p.title)}" width="48" height="48" style="border-radius:6px;object-fit:cover;background:var(--cream);flex-shrink:0;" loading="lazy">
          <div>
            <div style="font-size:14px;font-weight:600;">${escapeHTML(p.title)}</div>
            <div style="font-family:'Cormorant Garamond',serif;font-size:16px;">${money(p.price)}</div>
          </div>
        </a>
      `).join('');
    } catch (err) {
      results.innerHTML = '<p class="search-panel__hint">Error fetching results.</p>';
    }
  }

  // ── CHECKOUT LINK — bullet-proof fallback ──
  // If for ANY reason the <a href="/checkout"> doesn't navigate, force it with JS
  document.addEventListener('click', (e) => {
    const checkoutEl = e.target.closest('.btn--checkout, #checkout-link, [href="/checkout"]');
    if (checkoutEl) {
      // Don't interfere with product form buttons
      if (checkoutEl.closest('#product-form')) return;
      // Force navigation to /checkout
      window.location.href = '/checkout';
    }
  });

  // ── INIT CART ── (deferred: cart data only needed when drawer opens)
  // Pre-populate count badge from server-rendered value to avoid extra fetch
  const initCount = window.Strabella.cartItemCount || 0;
  $$('#cart-count, .cart-count').forEach(el => {
    el.textContent = initCount;
    el.setAttribute('aria-hidden', initCount === 0 ? 'true' : 'false');
  });
  // Defer full cart fetch until idle — avoids blocking TTI
  (window.requestIdleCallback || setTimeout)(function() { fetchCart().then(updateCartUI); }, { timeout: 3000 });

  // ── COLLECTION PAGE FILTER ──
  const sortSelect = $('.collection-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

})();

/* ══════════════════════════════════════════════
   SHOPIFY THEME EDITOR SUPPORT
   ══════════════════════════════════════════════ */

// Re-init sections when Theme Editor adds/moves them
document.addEventListener('shopify:section:load', function(e) {
  const section = e.target;
  // Re-init carousels, accordions, etc inside section
  initAccordions(section);
  initVideoCarousel(section);
  initFAQ(section);
});

document.addEventListener('shopify:block:select', function(e) {
  // Scroll to selected block in editor
  e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

/* ══════════════════════════════════════════════
   PERFORMANCE: IMAGE LAZY LOADING POLYFILL
   ══════════════════════════════════════════════ */
if ('loading' in HTMLImageElement.prototype === false) {
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) { img.src = img.dataset.src; }
          if (img.dataset.srcset) { img.srcset = img.dataset.srcset; }
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    lazyImages.forEach(img => observer.observe(img));
  }
}

/* ══════════════════════════════════════════════
   COLLECTION: SORT URL
   ══════════════════════════════════════════════ */
document.getElementById('sort-by')?.addEventListener('change', function() {
  const url = new URL(window.location.href);
  url.searchParams.set('sort_by', this.value);
  window.location.href = url.toString();
});

/* ══════════════════════════════════════════════
   PRODUCT PAGE: NAMED INIT FUNCTIONS
   (called on section:load too)
   ══════════════════════════════════════════════ */
function initAccordions(ctx = document) {
  ctx.querySelectorAll('.acc-trigger').forEach(btn => {
    if (btn.dataset.initDone) return;
    btn.dataset.initDone = '1';
    btn.addEventListener('click', () => {
      const item = btn.closest('.acc-item');
      const isOpen = item.classList.contains('is-open');
      item.closest('.accordion')?.querySelectorAll('.acc-item.is-open').forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });
}

function initFAQ(ctx = document) {
  ctx.querySelectorAll('.faq-trigger').forEach(btn => {
    if (btn.dataset.initDone) return;
    btn.dataset.initDone = '1';
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('is-open');
      // Tüm açık FAQ'ları kapat + aria-expanded sıfırla
      ctx.querySelectorAll('.faq-item.is-open').forEach(i => {
        i.classList.remove('is-open');
        const t = i.querySelector('.faq-trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      // Tıklanan kapalıysa aç
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initVideoCarousel(ctx = document) {
  const track = ctx.querySelector('.video-carousel__track, .video-track');
  if (!track) return;
  const dots = ctx.querySelectorAll('.video-dot');
  if (!dots.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const idx = Array.from(track.children).indexOf(entry.target);
      dots.forEach((d, i) => d.classList.toggle('active', i === idx));
    });
  }, { root: track, threshold: 0.5 });
  Array.from(track.children).forEach(child => observer.observe(child));
}

/* Call on DOMContentLoaded (already deferred so DOM is ready) */
initAccordions();
initFAQ();
initVideoCarousel();

/* ══════════════════════════════════════════════
   BACK-IN-STOCK: VARIANT CHANGE EVENT
   ══════════════════════════════════════════════ */
// strabella:variantChanged event is dispatched by back-in-stock.liquid
// when it detects variant changes via its own listener.

/* ══════════════════════════════════════════════
   STICKY ATC: SCROLL TRIGGER
   ══════════════════════════════════════════════ */
const stickyAtc = document.getElementById('sticky-atc');
const atcAreaEl = document.getElementById('product-form');
if (stickyAtc && atcAreaEl) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      stickyAtc.classList.toggle('is-visible', !e.isIntersecting);
    });
  }, { threshold: 0, rootMargin: '-68px 0px 0px 0px' });
  observer.observe(atcAreaEl);
}

/* ══════════════════════════════════════════════
   CART: HANDLE AJAX ERRORS GRACEFULLY
   ══════════════════════════════════════════════ */
window.addEventListener('unhandledrejection', function(e) {
  if (e.reason?.message?.includes('cart')) {
    console.warn('Cart operation failed:', e.reason);
    e.preventDefault();
  }
});
